define(['prop-types', 'santaProps/utils/propsSelectorsUtils'], function (PropTypes, propsSelectorsUtils) {
    'use strict';

    const createGlobalSantaType = propsSelectorsUtils.createGlobalSantaType;

    const allTheme = createGlobalSantaType(PropTypes.object, function (state) {
        return state.siteData.getAllStylesFromPossiblyRenderedRoots();
    }, 'allTheme');

    // TODO Mobx - Duplicate santa types!
    const themeColor = createGlobalSantaType(PropTypes.array, function (state) {
        return state.siteData.getColorsMap();
    }, 'themeColor');

    const colorsMap = createGlobalSantaType(PropTypes.array, function (state) {
        return state.siteData.getColorsMap();
    }, 'colorsMap');

    const THEME_DATA = createGlobalSantaType(PropTypes.object, function (state) {
        return state.siteData.getGeneralTheme();
    }, 'THEME_DATA');

    return {
        all: allTheme,
        colors: themeColor,
        colorsMap,
        THEME_DATA
    };
});
